import { MaxPlanInformationFormModal } from "@features/MaxPlanInformationFormModal/MaxPlanInformationFormModal";
import { type IMainSelectionPlanCard } from "@features/Plans/components/MainSelectionPlanCard";
import { PlanCard } from "@features/Plans/components/PlanCard";
import { useModalActions } from "@store/modal/modal";
import { PlanId } from "@services/jointBillServiceProviderBillPlans/types";
import { maxPlansMetadata } from "@utils/plans/constants";

const planOrderClassNames: Record<string, string> = {
  [PlanId.MCI]: "order-0",
  [PlanId.MBI]: "order-1",
  [PlanId.MAX]: "order-2",
};

interface IMaxPlanSelectionPlanCardProps extends IMainSelectionPlanCard {
  onComplete: () => void;
}

export const MaxPlanSelectionPlanCard: React.FC<
  IMaxPlanSelectionPlanCardProps
> = (props) => {
  const { jointBillServiceId, jointBillServicePlanId, onComplete } = props;
  const { create } = useModalActions();

  const onOrderClick = () => {
    create((modalProps) => (
      <MaxPlanInformationFormModal
        {...modalProps}
        jointBillServiceId={jointBillServiceId}
        jointBillServicePlanId={jointBillServicePlanId}
        onComplete={() => {
          onComplete();
        }}
      />
    ));
  };

  const maxPlanMetadata = maxPlansMetadata[jointBillServicePlanId];

  if (!maxPlanMetadata) {
    return null;
  }

  return (
    <PlanCard
      {...props}
      {...maxPlanMetadata}
      onOrderClick={onOrderClick}
      className={planOrderClassNames[jointBillServicePlanId]}
      headerClassName="h-[4.5rem]"
    />
  );
};
